/** Intention keys — match Firestore / seedBerlinMocks / discovery filters. */
export const INTENTION_IDS = [
  'physical',
  'softnight',
  'drink',
  'takeout',
  'dayout',
  'online',
] as const;

export type IntentionId = (typeof INTENTION_IDS)[number];

export const MAX_INTENTIONS = 2;
